import * as React from "react";
import { Card, CardContent, CardDescription, CardTitle } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Badge } from "@/components/ui/badge";
const menuHighlights = [{
  id: "residential",
  title: "Residential Cleaning",
  description: "Keep your home sparkling with our signature deep-cleaning and maintenance services. We handle the dust so you can enjoy the sunshine.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1635001/img/clean_bright_florida_home_interiors.png",
  badge: "Home Sweet Home"
}, {
  id: "commercial",
  title: "Commercial Cleaning",
  description: "Professional environments demand professional care. We provide meticulous janitorial services for offices and retail spaces in Vero Beach.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1635001/img/clean_office_space.png",
  price: "Custom",
  priceSuffix: "quotes"
}, {
  id: "vacation-rentals",
  title: "Vacation Rentals",
  description: "Maximize your 5-star reviews with expert Airbnb turnovers. We provide crisp linens, detailed staging, and reliable cleaning schedules.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1635001/img/fresh_airbnb_bedroom_with_white_linens.png",
  emphasis: "Learn More →"
}];
export default function CuratedDelights() {
  return <section data-section-id="222555" id="our-specialized-care" className="bg-secondary/30 py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl text-primary mb-4">
            Our Specialized Care
          </h2>
          <p className="text-foreground/70 font-sans max-w-2xl mx-auto leading-relaxed">
            Professional cleaning services tailored to the unique needs of Florida coastal homes, offices, and seasonal vacation rentals.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {menuHighlights.map((item, i) => <Card key={item.id} data-index={i} className="group bg-card border-none rounded-2xl shadow-xl shadow-foreground/5 flex flex-col overflow-hidden transition-transform duration-300 hover:scale-[1.02]">
              <div className="overflow-hidden">
                <AspectRatio ratio={1}>
                  <img src={item.image} alt={item.title} className="object-cover w-full h-full transition-transform duration-700 ease-out group-hover:scale-110" />
                </AspectRatio>
              </div>
              
              <CardContent className="p-6 md:p-8 flex flex-col grow">
                <div className="h-[2px] w-12 bg-accent mb-6" aria-hidden="true" />
                
                <CardTitle className="font-default text-2xl text-primary mb-4">
                  {item.title}
                </CardTitle>

                <div className="mb-4 min-h-[2rem] flex items-center">
                  {item.badge && <Badge variant="outline" className="border-primary/20 text-primary font-default rounded-full px-4 py-1 text-xs uppercase tracking-wider">
                      {item.badge}
                    </Badge>}
                  
                  {item.price && <div className="flex items-baseline gap-2">
                      <span className="font-default text-3xl text-primary">{item.price}</span>
                      <span className="text-muted-foreground text-sm font-sans">{item.priceSuffix}</span>
                    </div>}
                  
                  {item.emphasis && <span className="font-default text-primary text-base font-semibold border-b-2 border-primary/20 hover:border-primary transition-colors cursor-pointer">
                      {item.emphasis}
                    </span>}
                </div>

                <CardDescription className="text-foreground/90 font-sans text-base leading-relaxed mt-auto">
                  {item.description}
                </CardDescription>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}